import {
  Col,
  Row,
  Space,
  Button,
  Popover,
  Table,
  Typography,
  notification,
} from "antd";
import React, {useEffect, useRef, useState} from "react";
import Icons from "assets/icons";
import {WorkingCatalogColumns as columnsInit} from "./WorkingCatalog.config";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ModalAction from "./ModalAction/ModalAction";
import {ListActionButton} from "components/common";
import {employeeService} from "api";
import Notification from "../../../../../../../../components/common/notification/notification";
import {ColumnProps} from "../../../../../../../../types/models";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { saveTableOptions,getTableOptions } from "helper/common";

const WorkingCatalog = () => {
  const modalRef = useRef<any>();
  let savedTableOption = getTableOptions(
    "WORKINGCATALOG_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? columnsInit.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : columnsInit;
  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter(item => item.show === true)
  );
  columns.find((e)=> e.dataIndex === "index").render=(text,record,index) =>{
    const rowNumber =(currentPage - 1) * params.limit + index + 1;
    return rowNumber;
  }
  const [data, setData] = useState([]);
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [params, setParams] = useState<any>({
    limit: 1000,
    page: 1,
  });

  useEffect(() => {
    getList(params);
  }, [params]);

  columns.map(col => {
    if (col.dataIndex == "action") {
      col.render = (value, record, index) => {
        return (
          <ListActionButton
            // key={index}
            deleteFunction={() => deleteAction(record)}
            editFunction={() => {
              setType("Sửa");
              setRecord(record);
              modalRef.current?.openModal();
            }}
          />
        );
      };
    }
  });

  const getList = async (params) => {
    setLoading(true);
    try {
      const response = await employeeService.getWorking(params)
        .then(res => {
          setData(res.data);
          setTotal(res.total);
        });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      
    }
  };

  const handleOnAdd = () => {
    setType("Thêm");
    setRecord(null);
    modalRef.current?.openModal();
  };
  // useEffect(() => {
  //   setColumns(
  //       columnsInit.map(col => {
  //         if (!col.editable) {
  //           if (col.dataIndex === "index") {
  //             return {
  //               title: "STT",
  //               key: "index",
  //               show: true,
  //               dataIndex: "index",
  //               render(_, __, index) {
  //                 return <>{index + 1 + (params.page - 1) * params.limit}</>;
  //               },
  //               fixed: "left",
  //               width: 50,
  //               align: "center",
  //               isResizable: true,
  //             };
  //           } else {
  //             return col;
  //           }
  //         }
  //         return {
  //           ...col,
  //           onCell: (record: any) => ({
  //             record,
  //             editable: true,
  //             dataIndex: col.dataIndex,
  //             title: col.title,
  //             handleSave,
  //           }),
  //         };
  //       })
  //           .filter(e => e.show == true)
  //   );
  // }, [data]);
  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setData(newData);
  };
  const deleteAction = async record => {
    setLoading(true);
    try {
      const response = await employeeService
        .deleteWorking(record.id)
        .then((res) => {
          Notification("success", "Xoá thành công");
        });
      getList(params);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      
      Notification("error", "Đã có lỗi xảy ra khi xoá");
    }
  };
  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  const setShowColumnsList = showColumns => {
    saveTableOptions(
      "WORKINGCATALOG_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  return (
    <div className="container">
      <Space direction="vertical" style={{width: "100%"}} size={"middle"}>
{/* 
        <Row justify={"end"}>
          <Col>
            <Space>
              <Button
                type="primary"
                icon={<Icons.add rev={0} />}
                onClick={handleOnAdd}
              >
                Thêm mới
              </Button>
            </Space>
          </Col>
        </Row> */}
        <CustomResizableTable
            loading={loading}
            setShowColumns={setShowColumnsList}
            bordered
            columns={columns}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              onChange: onChangePagination,
              total: total,
              current: currentPage,
            }}
            dataSource={data}
            scroll={{ x: scrollX }}
        ></CustomResizableTable>
      </Space>
      <ModalCustom ref={modalRef} width={1000} title={`${type} số giờ làm việc/tuần`}>
        <ModalAction
          data={record}
          getListStore={getList}
          type={type}
        ></ModalAction>
      </ModalCustom>
    </div>
  );
};

export default WorkingCatalog;
